import { useEffect, useRef } from "react";

export default function StreetView({ lat, lon, heading = 0 }) {
  const containerRef = useRef(null);
  const panoRef = useRef(null); // store the panorama instance

  useEffect(() => {
    if (!window.google || !containerRef.current) return;

    // Create StreetView panorama once
    if (!panoRef.current) {
      panoRef.current = new window.google.maps.StreetViewPanorama(
        containerRef.current,
        {
          position: { lat, lng: lon },
          pov: { heading, pitch: 0 },
          zoom: 1,
          visible: true
        }
      );
    } else {
      // Update whenever props change
      panoRef.current.setPosition({ lat, lng: lon });
      const forwardHeading = (heading + 180) % 360;
      panoRef.current.setPov({ heading: forwardHeading, pitch: 0 });
    }
  }, [lat, lon, heading]);

  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "220px",
        borderRadius: "6px",
        overflow: "hidden"
      }}
    />
  );
}
